import { render, staticRenderFns } from "./AllowanceConfig.vue?vue&type=template&id=049760d2&scoped=true"
import script from "./AllowanceConfig.vue?vue&type=script&lang=js"
export * from "./AllowanceConfig.vue?vue&type=script&lang=js"
import style0 from "./AllowanceConfig.vue?vue&type=style&index=0&id=049760d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049760d2",
  null
  
)

export default component.exports